module.exports = __webpack_public_path__ + "img/behold-16.a1fcf726.png";